/*@jsxRuntime automatic @jsxImportSource react*/
/*<!-- vale Google.Acronyms = NO -->*/
/*<!-- vale Google.Acronyms = YES -->*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1789430400000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Tue Sep 15 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "snapchat",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Supported syncing",
          "depth": 0,
          "id": "supported-syncing"
        }, {
          "value": "Connect to Snapchat",
          "depth": 0,
          "id": "connect-to-snapchat"
        }, {
          "value": "Sync configuration",
          "depth": 0,
          "id": "sync-configuration"
        }, {
          "value": "Syncing segments",
          "depth": 1,
          "id": "syncing-segments"
        }, {
          "value": "Syncing conversion events",
          "depth": 1,
          "id": "syncing-conversion-events"
        }, {
          "value": "PII hashing",
          "depth": 1,
          "id": "pii-hashing"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Matched users count",
          "depth": 1,
          "id": "matched-users-count"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      a: "a",
      strong: "strong",
      p: "p",
      img: "img",
      h3: "h3",
      h4: "h4",
      ul: "ul",
      li: "li",
      code: "code"
    }, _provideComponents(), props.components), {MatchBoosterDestination, ArrayFanOutTip, EventSyncWarning, MatchRatesExplanation, NoCommonErrors, LiveDebugger, SyncAlerts} = _components;
    if (!ArrayFanOutTip) _missingMdxReference("ArrayFanOutTip", true);
    if (!EventSyncWarning) _missingMdxReference("EventSyncWarning", true);
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!MatchBoosterDestination) _missingMdxReference("MatchBoosterDestination", true);
    if (!MatchRatesExplanation) _missingMdxReference("MatchRatesExplanation", true);
    if (!NoCommonErrors) _missingMdxReference("NoCommonErrors", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "supported-syncing",
        children: "Supported syncing"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Sync type"
            }), _jsx(_components.th, {
              children: "Description"
            }), _jsx(_components.th, {
              children: "Supported sync modes"
            }), _jsx(_components.th, {
              children: "API reference"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "#syncing-segments",
                children: _jsx(_components.strong, {
                  children: "Segments"
                })
              })
            }), _jsx(_components.td, {
              children: "Create and keeps audience segments up-to-date in Snapchat"
            }), _jsx(_components.td, {
              children: "Add, Remove, Update"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://marketingapi.snapchat.com/docs/#create-an-audience-segment",
                children: "Audience segment docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "#syncing-conversion-events",
                children: _jsx(_components.strong, {
                  children: "Conversion Events"
                })
              })
            }), _jsx(_components.td, {
              children: "Create and send conversion events to Snapchat"
            }), _jsx(_components.td, {
              children: "Insert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://marketingapi.snapchat.com/docs/conversion.html#conversions-api",
                children: "Conversions API docs"
              })
            })]
          })]
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["For more information about sync modes, refer to the ", _jsx(_components.a, {
          href: "/syncs/types-and-modes#sync-modes",
          children: "sync modes"
        }), " docs."]
      }), "\n", _jsx(_components.h2, {
        id: "connect-to-snapchat",
        children: "Connect to Snapchat"
      }), "\n", _jsxs(_components.p, {
        children: ["Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/destinations?from=docs",
          children: [_jsx(_components.strong, {
            children: "Destinations"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add destination"
        }), " button. Select ", _jsx(_components.strong, {
          children: "Snapchat"
        }), " and click ", _jsx(_components.strong, {
          children: "Continue"
        }), ". You can then authenticate Hightouch to ", _jsx(_components.strong, {
          children: "Snapchat"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["For the ", _jsx(_components.strong, {
          children: "Authentication method"
        }), ", select ", _jsx(_components.strong, {
          children: "Log in to Snapchat"
        }), " and log into your Snapchat account.\nThen, authorize Hightouch to access your Snapchat account:\n", _jsx(_components.img, {
          src: "destinations/destination-snapchat-oauth-connect.png",
          alt: "OAuth flow for Snapchat"
        })]
      }), "\n", _jsx(_components.p, {
        children: "Once successful, you will be redirected back to Hightouch.\nThere, select the Snapchat business organization you want to sync data to.\nFinally enter a descriptive name for your destination to complete setup."
      }), "\n", _jsx(_components.h2, {
        id: "sync-configuration",
        children: "Sync configuration"
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've set up your Snapchat destination and have a ", _jsx(_components.a, {
          href: "/getting-started/concepts#models",
          children: "model"
        }), " to pull data from, you can set up your sync configuration to begin syncing data. Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/syncs?from=docs",
          children: [_jsx(_components.strong, {
            children: "Syncs"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add sync"
        }), " button to begin. Then, select the relevant model and the Snapchat destination you want to sync to."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-segments",
        children: "Syncing segments"
      }), "\n", _jsxs(_components.p, {
        children: ["You can use Hightouch to create and keep audience segments in Snapchat up-to-date using ", _jsx(_components.a, {
          href: "https://marketingapi.snapchat.com/docs/",
          children: "Snapchat's Ads API"
        }), ".\nBegin by selecting the Snapchat Ad Account your audience segments should belong to."]
      }), "\n", _jsx(_components.h4, {
        id: "select-an-existing-audience-or-create-a-new-one",
        children: "Select an existing audience or create a new one"
      }), "\n", _jsx(_components.p, {
        children: "You can create a new audience segment or use an existing one. When creating a new audience, you can optionally enter a name; otherwise, Hightouch defaults to the name of the associated model. To use an existing audience, select the desired audience from the dropdown."
      }), "\n", _jsx(_components.h4, {
        id: "audience-member-retention",
        children: "Audience member retention"
      }), "\n", _jsx(_components.p, {
        children: "You can specify a custom retention period that an audience segment should retain members.\nSnapchat's default is 9,999 days.\nYou can only set custom values when first creating an audience segment.\nIf you want to set a new retention period, you need to create a new sync."
      }), "\n", _jsx(_components.h4, {
        id: "user-identifiers",
        children: "User identifiers"
      }), "\n", _jsx(_components.p, {
        children: "To identify which users to add or update in an audience, select model columns and the corresponding Snapchat fields. You can match on any of the following Snapchat fields:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Email"
        }), "\n", _jsx(_components.li, {
          children: "Phone"
        }), "\n", _jsx(_components.li, {
          children: "Mobile ID"
        }), "\n"]
      }), "\n", _jsx(MatchBoosterDestination, {
        destinationName: "Snapchat audience segments"
      }), "\n", _jsx(ArrayFanOutTip, {
        destinationName: "Snapchat"
      }), "\n", _jsx(_components.h3, {
        id: "syncing-conversion-events",
        children: "Syncing conversion events"
      }), "\n", _jsx(Warning, {
        children: _jsx(_components.p, {
          children: "Version 2 is Snapchat's legacy Conversions API. New syncs default to Version\n3. Hightouch doesn't migrate existing Version 2 syncs automatically: they keep\nrunning on Version 2 until you switch the version in the sync configuration\nand map your fields in the Version 3 mapping groups."
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Snapchat's ", _jsx(_components.a, {
          href: "https://marketingapi.snapchat.com/docs/conversion.html",
          children: "Conversions API"
        }), " requires the following event parameters:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["event name (named ", _jsx(_components.code, {
            children: "event_type"
          }), " in Snapchat's Conversions API)"]
        }), "\n", _jsxs(_components.li, {
          children: ["event conversion type (", _jsx(_components.code, {
            children: "event_conversion_type"
          }), ")"]
        }), "\n", _jsxs(_components.li, {
          children: ["event tag (", _jsx(_components.code, {
            children: "event_tag"
          }), ")"]
        }), "\n", _jsx(_components.li, {
          children: "timestamp"
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["The sync configuration form ensures all these are set and provides some additional options.\nFor more information about Snapchat's Conversions API and it's prerequisites, check out ", _jsx(_components.a, {
          href: "https://businesshelp.snapchat.com/s/article/api-apply?language=en_US",
          children: "Snapchat's API help article"
        }), "."]
      }), "\n", _jsx(EventSyncWarning, {}), "\n", _jsx(_components.h4, {
        id: "event-name-and-conversion-type",
        children: "Event name and conversion type"
      }), "\n", _jsxs(_components.p, {
        children: ["Providing an event name is required to send an event to the Conversions API. You can either provide a static value or select to ", _jsx(_components.strong, {
          children: "use a column"
        }), " from your model.\nYou can select your event conversion type in the same way."]
      }), "\n", _jsx(_components.p, {
        children: "Snapchat's Conversions API accepts the following values:"
      }), "\n", "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Name"
            }), _jsx(_components.th, {
              children: "Values"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.code, {
                children: "event_type"
              })
            }), _jsx(_components.td, {
              children: "\"PURCHASE,\" \"SAVE,\" \"START_CHECKOUT,\" \"ADD_CART,\" \"VIEW_CONTENT,\" \"ADD_BILLING,\" \"SIGN_UP,\" \"SEARCH,\" \"PAGE_VIEW,\" \"SUBSCRIBE,\" \"AD_CLICK,\" \"AD_VIEW,\" \"COMPLETE_TUTORIAL,\" \"INVITE,\" \"LOGIN,\" \"SHARE,\" \"RESERVE,\" \"ACHIEVEMENT_UNLOCKED,\" \"ADD_TO_WISHLIST,\" \"SPENT_CREDITS,\" \"RATE,\" \"START_TRIAL,\" \"LIST_VIEW,\" \"APP_INSTALL,\" \"APP_OPEN,\" \"CUSTOM_EVENT_1,\" \"CUSTOM_EVENT_2,\" \"CUSTOM_EVENT_3,\" \"CUSTOM_EVENT_4,\" \"CUSTOM_EVENT_5\""
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.code, {
                children: "event_conversion_type"
              })
            }), _jsx(_components.td, {
              children: "\"OFFLINE,\" \"WEB,\" \"MOBILE_APP\""
            })]
          })]
        })]
      }), "\n", "\n", _jsxs(_components.p, {
        children: ["See the ", _jsx(_components.a, {
          href: "https://marketingapi.snapchat.com/docs/conversion.html#parameters-for-event-type-platform",
          children: "Snapchat Marketing API documentation"
        }), " for more information about event parameters."]
      }), "\n", _jsx(_components.h4, {
        id: "event-timestamp",
        children: "Event timestamp"
      }), "\n", _jsx(_components.p, {
        children: "You can optionally select a column that contains timestamps of when events occurred. If this field is empty, Hightouch uses the time the event arrives at the server."
      }), "\n", _jsx(_components.p, {
        children: "If you select a column, it should be in UNIX timestamp, calculated in seconds or milliseconds."
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping",
        children: "Field mapping"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch lets you sync event properties via field mapping.\nYou must include the ", _jsx(_components.strong, {
          children: "event tag"
        }), " field that Snapchat's Conversions API requires for each event.\nEvent tags are custom values you create, for example, \"in-store,\" \"weekend sales,\" \"back-to-school campaign,\" etc."]
      }), "\n", _jsxs(_components.p, {
        children: ["Check out Snapchat's ", _jsx(_components.a, {
          href: "https://marketingapi.snapchat.com/docs/conversion.html#conversion-parameters",
          children: "Conversion parameters documentation"
        }), " for more information about the parameters you can map."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.strong, {
          children: "Version 3"
        })
      }), "\n", _jsx(_components.p, {
        children: "The new version of the conversion API takes many of the same parameters as the previous version but they are split into multiple mapping groups."
      }), "\n", _jsxs(_components.p, {
        children: ["Checkout Snapchat's version 3 ", _jsx(_components.a, {
          href: "https://docs.snap.com/api/marketing-api/Conversions-API/Parameters",
          children: "Conversion parameters documentation"
        }), " for more information about the parameters you can map."]
      }), "\n", _jsx(_components.h3, {
        id: "pii-hashing",
        children: "PII hashing"
      }), "\n", _jsx(_components.p, {
        children: "Snapchat requires identity information to be normalized and hashed using a SHA256 hash.\nEnable PII hashing if you wish for Hightouch to normalize and hash these values for you.\nIf you turn off PII hashing, you must ensure your model data is hashed before sending it to Snapchat."
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(_components.h3, {
        id: "matched-users-count",
        children: "Matched users count"
      }), "\n", _jsx(_components.p, {
        children: "Below only applies to the segment sync type."
      }), "\n", _jsx(MatchRatesExplanation, {
        destination: "Snapchat Ads"
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(NoCommonErrors, {}), "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
